<template>
  <weui-group v-if="stepCount" :notitle="true">
    <weui-cell>
      <div class="steps">
        <div v-for="(step, index) in steps" :class="step.class" :key="index">{{ step.text }}</div>
      </div>
    </weui-cell>
  </weui-group>
</template>

<script>
import { WeuiGroup, WeuiCell } from '@/components/weui';

const STEPS = ['第一步', '第二步', '第三步', '第四步', '第五步'];


export default {
    props: {
        stepCount: {
            type: Number,
            required: true,
        },
        currentStep: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        steps() {
            const steps = [];
            for (let i = 0; i < this.stepCount; i += 1) {
                steps.push({
                    text: STEPS[i],
                    class: (i === this.currentStep) ? 'step active' : 'step',
                });

                if (i + 1 < this.stepCount) {
                    steps.push({
                        text: '>',
                        class: 'step-separator',
                    });
                }
            }

            return steps;
        },
    },
    components: {
        WeuiGroup,
        WeuiCell,
    },
};
</script>

<style lang="scss" scoped>
@import './../../assets/scss/variables';

.steps {
    display: flex;
    justify-content: center;
    align-items: center;
}

.step-separator {
    width: 30px;
    flex: none;
    color: $text-color;
}

.step {
    flex: auto;
    text-align: center;
    color: $text-color;

    &.active {
        color: $blue;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/share/Steps.vue